import React, { useState, useEffect } from 'react'
import "../css/Header.css"
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useLoginContext } from './LoginContext';
import { useActivePage } from './ActivePageContext';
import InquiryForm from './InquiryForm';
import { ToastContainer } from 'react-toastify';


const Top = () =>{
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    return(
        <>
            <div className='top'>
                <div className="top-brand">
                    <p className="top-brand-text">Industrial Parts (U) Ltd</p>
                </div>
                <div className='top-actions' role="navigation" aria-label="Quick links">
                    <a className='top-link' href="https://wa.me/256775871105?text=Hi,%20I'm%20interested%20in%20your%20services" target="_blank" rel="noopener noreferrer">
                        <i className='fab fa-whatsapp' aria-hidden="true"></i>
                        <span>WhatsApp</span>
                    </a>
                    <Link className='top-link' to='/contact-us'>Contact us</Link>
                    <button type="button" className="top-link top-link--btn" onClick={openModal}>
                        <span>Inquiries</span>
                        <i className="fa-solid fa-circle-question" aria-hidden="true"></i>
                    </button>
                    <Link className='top-link' to='/login'>Login</Link>
                    <span className="top-social" aria-hidden="true">
                        <i className="fa-brands fa-twitter"></i>
                        <i className="fa-brands fa-facebook-f"></i>
                    </span>
                </div>
                <InquiryForm isOpen={isModalOpen} onClose={closeModal} />
            </div>
            <ToastContainer />
        </>
    )
}

const Navigator = () => {
    const { activePage, setActivePage } = useActivePage();
    const [search, setSearch] = useState("")
    const [mobileNavOpen, setMobileNavOpen] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    const { isLoggedIn } = useLoginContext();

    useEffect(() => {
        setMobileNavOpen(false)
    }, [location.pathname])

    const handleSearch = async(e) => {
        e.preventDefault()
        navigate(`/search?name=${search}`, { state: { search: search } });
    }

    const navLinkClass = (pageMatch) =>
        activePage === pageMatch ? 'active' : ''

    return(
        <div className='navigator'>
            <button
                type="button"
                className={`nav-mobile-toggle ${mobileNavOpen ? 'is-open' : ''}`}
                onClick={() => setMobileNavOpen((o) => !o)}
                aria-expanded={mobileNavOpen}
                aria-controls="primary-navigation"
                id="nav-menu-button"
            >
                <span className="nav-mobile-toggle-bars" aria-hidden>
                    <span />
                    <span />
                    <span />
                </span>
                <span className="visually-hidden">{mobileNavOpen ? 'Close menu' : 'Open menu'}</span>
            </button>

            <nav
                id="primary-navigation"
                className={`navigator-nav ${mobileNavOpen ? 'is-open' : ''}`}
                aria-label="Primary"
            >
                {isLoggedIn === true && (
                    <Link to={"/dashboard"} onClick={()=>setActivePage("dashboard")} className={navLinkClass('dashboard')}>Dashboard</Link>
                )}
                <Link to={"/"} onClick={()=>setActivePage("")} className={navLinkClass('')}>HOME</Link>
                <Link to={"/about"} onClick={()=>setActivePage("about")} className={navLinkClass('about')}>ABOUT</Link>
                <Link to={"/team"} onClick={()=>setActivePage("team")} className={navLinkClass('team')}>TEAM</Link>
                <Link to={"/contact-us"} onClick={()=>setActivePage("contact")} className={navLinkClass('contact')}>CONTACT US</Link>
                <Link to={"/cart"} onClick={()=>setActivePage("cart")} className={navLinkClass('cart')}>CART</Link>
                <Link to={"/quotation"} onClick={()=>setActivePage("quotation")} className={`navigator-nav-cta ${navLinkClass('quotation')}`}>QUOTATION</Link>
            </nav>

            <form className='navigator-search' onSubmit={handleSearch} role="search">
                <input type='search' placeholder='Search industrial parts' name='name' value={search} onChange={(e)=>setSearch(e.target.value)} aria-label="Search products" />
                <button type="submit" className='navigator-search-btn' aria-label="Search">
                    <i className="fa-solid fa-magnifying-glass"></i>
                </button>
            </form>
        </div>
    )
}

const Header = () => {
  return (
    <div className='header'>
        <Top />
        <Navigator />
    </div>
  )
}

export default Header
